import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { BuildColumnFormatter } from "./titleFormatter";

import React from "react";
const timeOfAccidentFormatter = (value) => {
  if (!value) return null;
  const [hourStr, minute] = value.split(":");
  let hour = parseInt(hourStr, 10);
  const isPM = hour >= 12;
  const isAM = !isPM;
  hour = hour % 12 || 12;
  const time12 = `${hour}:${minute}`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "24px",
      }}
    >
      <span>{time12}</span>
      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{ marginRight: "8px" }}>AM</span>
          <TickBox flag={isAM} />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{ marginRight: "8px" }}>PM</span>
          <TickBox flag={isPM} />
        </div>
      </div>
    </div>
  );
};
const codeFormatter = (data) => (values) => {
  if (!values) return null;

  const arr = Array.isArray(values) ? values : [];

  const result = arr
    .map(function (checked, i) {
      if (!checked) return null;
      if (i === 0) return null;

      if (i === 11) {
        var otherText = arr[12];
        return otherText ? "11 (" + otherText + ")" : "11";
      }

      if (i === 12) return null;

      var dataIndex = i > 12 ? i - 2 : i - 1;

      if (data && data[dataIndex] && data[dataIndex].key) {
        return data[dataIndex].key;
      }

      return null;
    })
    .filter(function (x) {
      return x;
    })
    .join(", ");

  return <span>{result}</span>;
};
const highwayNameFormatter = (value) => {
  if (!value) return null;

  const [number, ownerShip] = value;
  const isPublic = ownerShip === "Public";
  const isPrivate = ownerShip === "Private";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "24px",
      }}
    >
      <span>{number}</span>

      <div style={{ display: "flex", gap: "20px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "8px" }}>Public</span>
          <TickBox flag={isPublic} />
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "8px" }}>Private</span>
          <TickBox flag={isPrivate} />
        </div>
      </div>
    </div>
  );
};

const specialStudyBlockFormatter = (value) => {
  if (!value) return null;

  const parts = value;
  const videoTaken = parts[0];
  const videoUsed = parts[1];

  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "110px 50px 50px",
    alignItems: "center",
    columnGap: "20px",
  };

  const optionStyle = {
    display: "flex",
    alignItems: "center",
    paddingLeft: "0px",
  };

  return (
    <div style={{ fontSize: "12px", display: "flex", flexDirection: "column", gap: "6px" }}>
      <div style={rowStyle}>
        <span>Video Taken?</span>

        <div style={optionStyle}>
          <TickBox flag={videoTaken === "Yes"} />
          <span>Yes</span>
        </div>

        <div style={optionStyle}>
          <TickBox flag={videoTaken === "No"} />
          <span>No</span>
        </div>
      </div>
      <div style={rowStyle}>
        <span>Video Used?</span>

        <div style={optionStyle}>
          <TickBox flag={videoUsed === "Yes"} />
          <span>Yes</span>
        </div>

        <div style={optionStyle}>
          <TickBox flag={videoUsed === "No"} />
          <span>No</span>
        </div>
      </div>
    </div>
  );
};

const highwayUserTypeData = [
  { key: "A. ", value: "Auto" },
  { key: "B. ", value: "Truck" },
  { key: "C. ", value: "Truck-trailer" },
  { key: "D. ", value: "Pickup truck" },
  { key: "E. ", value: "Van" },
  { key: "F. ", value: "Bus" },
  { key: "G. ", value: "School bus" },
  { key: "H. ", value: "Motorcycle" },
  { key: "J. ", value: "Other motor vehicle" },
  { key: "K. ", value: "Pedestrian" },
  { key: "M. ", value: "Other (specify)" },
];
const HighwayUserTypeData = () =>
  BuildColumnFormatter({
    title: "13. Type",
    data: highwayUserTypeData,
    columns: 4,
    rowsPerColumn: 4,
  });

const directionData = [
  { key: "1. ", value: "North" },
  { key: "2. ", value: "South" },
  { key: "3. ", value: "East" },
  { key: "4. ", value: "West" },
];
const DirectionData = () =>
  BuildColumnFormatter({
    title: "15. Direction",
    data: directionData,
    columns: 2,
    rowsPerColumn: 2,
  });

const positionData = [
  { key: "1. ", value: "Stalled or stuck on crossing" },
  { key: "2. ", value: "Stopped on crossing" },
  { key: "3. ", value: "Moving over crossing" },
  { key: "4. ", value: "Trapped on crossing by traffic" },
  { key: "5. ", value: "Blocked on crossing by gates" },
];
const PositionData = () =>
  BuildColumnFormatter({
    title: "16. Position",
    data: positionData,
    columns: 2,
    rowsPerColumn: 3,
  });

const equipmentData = [
  { key: "1. ", value: "Train (units pulling)" },
  { key: "2. ", value: "Train (units pushing)" },
  { key: "3. ", value: "Train (standing)" },
  { key: "4. ", value: "Car(s) (moving)" },
  { key: "5. ", value: "Car(s) (standing)" },
  { key: "6. ", value: "Light loco(s) (moving)" },
  { key: "7. ", value: "Light loco(s) (standing)" },
  { key: "8. ", value: "Other (specify)" },
  { key: "A. ", value: "Train pulling - RCL" },
  { key: "B. ", value: "Train pushing - RCL" },
  { key: "C. ", value: "Train standing - RCL" },
  { key: "D. ", value: "EMU Locomotive(s)" },
  { key: "E. ", value: "DMU Locomotive(s)" },
];
const EquipmentData = () =>
  BuildColumnFormatter({
    title: "17. Equipment",
    data: equipmentData,
    columns: 4,
    rowsPerColumn: 5,
  });

const circumstanceData = [
  { key: "1. ", value: "Rail equipment struck highway user" },
  { key: "2. ", value: "Rail equipment struck by highway user" },
];
const CircumstanceData = () =>
  BuildColumnFormatter({
    title: "19. Circumstance",
    data: circumstanceData,
    columns: 1,
    rowsPerColumn: 2,
  });

const hazardousMaterialInvolvedData = [
  { key: "1. ", value: "Highway user" },
  { key: "2. ", value: "Rail equipment" },
  { key: "3. ", value: "Both" },
  { key: "4. ", value: "Neither" },
];
const HazardousMaterialInvolvedData = () =>
  BuildColumnFormatter({
    title: "20a. Was the highway user and/or rail equipment involved in the impact transporting hazardous materials?",
    data: hazardousMaterialInvolvedData,
    columns: 2,
    rowsPerColumn: 2,
  });

const hazardousMaterialReleasedData = [
  { key: "1. ", value: "Highway user" },
  { key: "2. ", value: "Rail equipment" },
  { key: "3. ", value: "Both" },
  { key: "4. ", value: "Neither" },
];
const HazardousMaterialReleasedData = () =>
  BuildColumnFormatter({
    title: "20b. Was there a hazardous materials release by",
    data: hazardousMaterialReleasedData,
    columns: 2,
    rowsPerColumn: 2,
  });

const visibilityData = [
  { key: "1. ", value: "Dawn" },
  { key: "2. ", value: "Day" },
  { key: "3. ", value: "Dusk" },
  { key: "4. ", value: "Dark" },
];
const VisibilityData = () =>
  BuildColumnFormatter({
    title: "22. Visibility",
    data: visibilityData,
    columns: 2,
    rowsPerColumn: 2,
  });

const weatherData = [
  { key: "1. ", value: "Clear" },
  { key: "2. ", value: "Cloudy" },
  { key: "3. ", value: "Rain" },
  { key: "4. ", value: "Fog" },
  { key: "5. ", value: "Sleet" },
  { key: "6. ", value: "Snow" },
];
const WeatherData = () =>
  BuildColumnFormatter({
    title: "23. Weather",
    data: weatherData,
    columns: 2,
    rowsPerColumn: 3,
  });

const typeOfEquipmentData = [
  { key: "1. ", value: "Freight Train" },
  { key: "2. ", value: "Passenger Train-Pulling" },
  { key: "3. ", value: "Commuter Train-Pulling" },
  { key: "4. ", value: "Work train" },
  { key: "5. ", value: "Single car" },
  { key: "6. ", value: "Cut of cars" },
  { key: "7. ", value: "Yard/switching" },
  { key: "8. ", value: "Light loco(s)" },
  { key: "9. ", value: "Maint/Inspect car" },
  { key: "A. ", value: "Spec. MoW equip" },
  { key: "B. ", value: "Passenger Train-Pushing" },
  { key: "C. ", value: "Commuter Train-Pushing" },
  { key: "D. ", value: "EMU" },
  { key: "E. ", value: "DMU" },
];

const TypeOfEquipmentData = () =>
  BuildColumnFormatter({
    title: "24. Type of Equipment Consist",
    data: typeOfEquipmentData,
    columns: 4,
    rowsPerColumn: 4,
  });

const trackTypeUsedData = [
  { key: "1. ", value: "Main" },
  { key: "2. ", value: "Yard" },
  { key: "3. ", value: "Siding" },
  { key: "4. ", value: "Industry" },
];

const TrackTypeUsedData = () =>
  BuildColumnFormatter({
    title: "25. Track Type Used by Rail Equipment Involved",
    data: trackTypeUsedData,
    columns: 2,
    rowsPerColumn: 2,
  });

const timeTableDirectionData = [
  { key: "1. ", value: "North" },
  { key: "2. ", value: "South" },
  { key: "3. ", value: "East" },
  { key: "4. ", value: "West" },
];

const TimeTableDirectionData = () =>
  BuildColumnFormatter({
    title: "31. Time Table Direction",
    data: timeTableDirectionData,
    columns: 2,
    rowsPerColumn: 2,
  });

const locationOfWarningData = [
  { key: "1. ", value: "Both sides" },
  { key: "2. ", value: "Side of vehicle approach" },
  { key: "3. ", value: "Opposite side of vehicle approach" },
];

const LocationOfWarningData = () =>
  BuildColumnFormatter({
    title: "35. Location of Warning",
    data: locationOfWarningData,
    columns: 1,
    rowsPerColumn: 3,
  });

const crossingWarningInterconnectedData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
  { key: "3. ", value: "Unknown" },
];

const CrossingWarningInterconnectedData = () =>
  BuildColumnFormatter({
    title: "36. Crossing Warning Interconnected with Highway Signals",
    data: crossingWarningInterconnectedData,
    columns: 1,
    rowsPerColumn: 3,
  });

const crossingIlluminatedData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
  { key: "3. ", value: "Unknown" },
];

const CrossingIlluminatedData = () =>
  BuildColumnFormatter({
    title: "37. Crossing Illuminated by Street Lights or Special Lights",
    data: crossingIlluminatedData,
    columns: 1,
    rowsPerColumn: 3,
  });

const crossingWarningTypeData = [
  { key: "1", value: ". Gates" },
  { key: "2", value: ". Cantilever FLS" },
  { key: "3", value: ". Standard FLS" },
  { key: "4", value: ". Wig wags" },
  { key: "5", value: ". Hwy. traffic signals" },
  { key: "6", value: ". Audible" },
  { key: "7", value: ". Crossbucks" },
  { key: "8", value: ". Stop signs" },
  { key: "9", value: ". Watchman" },
  { key: "10", value: ". Flagged by crew" },
  { key: "11", value: ". Other (specify)" },
  { key: "12", value: ". None" },
];
const CrossingWarningTypeData = () =>
  BuildColumnFormatter({
    title: "32. Type of Crossing Warning",
    data: crossingWarningTypeData,
    columns: 3,
    rowsPerColumn: 4,
  });

const roadwayConditionData = [
  { key: "A. ", value: "Dry" },
  { key: "B. ", value: "Wet" },
  { key: "C. ", value: "Snow/Slush" },
  { key: "D. ", value: "Ice" },
  { key: "E. ", value: "Sand, Mud, Dirt, Oil, Gravel" },
  { key: "F. ", value: "Water (Standing, Moving)" },
];
const RoadwayConditionData = () =>
  BuildColumnFormatter({
    title: "34. Roadway Conditions",
    data: roadwayConditionData,
    columns: 2,
    rowsPerColumn: 6,
  });

const highwayUserSexData = [
  { key: "1. ", value: "Male" },
  { key: "2. ", value: "Female" },
];
const HighwayUserSexData = () =>
  BuildColumnFormatter({
    title: "39. Highway User's Sex",
    data: highwayUserSexData,
    columns: 1,
    rowsPerColumn: 2,
  });

const highwayUserPositionData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
  { key: "3. ", value: "Unknown" },
];
const HighwayUserPositionData = () =>
  BuildColumnFormatter({
    title: "40. Highway user Went Behind or In Front of Train and Struck or was Struck by Second Train",
    data: highwayUserPositionData,
    columns: 3,
    rowsPerColumn: 1,
  });

const highwayUserActionData = [
  { key: "1. ", value: "Went around the gate" },
  { key: "2. ", value: "Stopped and then proceeded" },
  { key: "3. ", value: "Did not stop" },
  { key: "4. ", value: "Stopped on crossing" },
  { key: "5. ", value: "Other (specify)" },
  { key: "6. ", value: "Went around/thru temporary barricade (if yes, see instructions)" },
  { key: "7. ", value: "Went thru the gate" },
  { key: "8. ", value: "Suicide/Attempted suicide" },
];
const HighwayUserActionData = () =>
  BuildColumnFormatter({
    title: "41. Highway User",
    data: highwayUserActionData,
    columns: 2,
    rowsPerColumn: 4,
  });

const driverPassedStandingVehicleData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
  { key: "3. ", value: "Unknown" },
];
const DriverPassedStandingVehicleData = () =>
  BuildColumnFormatter({
    title: "42. Driver Passed Standing Highway Vehicle",
    data: driverPassedStandingVehicleData,
    columns: 3,
    rowsPerColumn: 1,
  });

const trackViewObstructionData = [
  { key: "1. ", value: "Permanent structure" },
  { key: "2. ", value: "Standing railroad equipment" },
  { key: "3. ", value: "Passing train" },
  { key: "4. ", value: "Topography" },
  { key: "5. ", value: "Vegetation" },
  { key: "6. ", value: "Highway vehicles" },
  { key: "7. ", value: "Other (specify)" },
  { key: "8. ", value: "Not obstructed" },
];
const TrackViewObstructionData = () =>
  BuildColumnFormatter({
    title: "43. View of Track Obscured by  (primary obstruction)",
    data: trackViewObstructionData,
    columns: 4,
    rowsPerColumn: 2,
  });

const driverConditionData = [
  { key: "1. ", value: "Killed" },
  { key: "2. ", value: "Injured" },
  { key: "3. ", value: "Uninjured" },
];
const DriverConditionData = () =>
  BuildColumnFormatter({
    title: "44. Driver Was",
    data: driverConditionData,
    columns: 3,
    rowsPerColumn: 1,
  });

const driverInVehicleData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
];
const DriverInVehicleData = () =>
  BuildColumnFormatter({
    title: "45. Was Driver in the Vehicle?",
    data: driverInVehicleData,
    columns: 2,
    rowsPerColumn: 1,
  });

const railIncidentReportData = [
  { key: "1. ", value: "Yes" },
  { key: "2. ", value: "No" },
];
const RailIncidentReportData = () =>
  BuildColumnFormatter({
    title: "51. Is a Rail Equipment Accident/Incident Report Being Filed?",
    data: railIncidentReportData,
    columns: 2,
    rowsPerColumn: 1,
  });

const constantSpeedData = [
  { key: "R", value: "-Recorded" },
  { key: "E", value: "-Estimated" },
  { key: "U", value: "-Unknown" },
];
const ConstantSpeedData = () =>
  BuildColumnFormatter({
    title: "30. Consist Speed",
    data: constantSpeedData,
    columns: 1,
    rowsPerColumn: 3,
  });

export const ReportSchema = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "1. Name of Reporting Railroad",
        // isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field1",
        topAlign: true,
      },
      {
        title: "1a. Alphabetic Code",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        accessor: "field1a",
      },
      {
        title: "1b. Railroad Accident/Incident No.",
        // isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field1b",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "2. Name of Other Railroad or Other Entity Filing for Equipment involved In Train Accident/lncident",
        // isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field2",
        topAlign: true,
      },
      {
        title: "2a. Alphabetic Code",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field2a",
        topAlign: true,
      },
      {
        title: "2b. Railroad Accident/Incident No.",
        // isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field2b",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "3. Name of Railroad or Other Entity Responsible for Track Maintenance",
        // isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field3",
        topAlign: true,
      },
      {
        title: "3a. Alphabetic Code",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field3a",
        topAlign: true,
      },
      {
        title: "3b. Railroad Accident/Incident No.",
        // isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field3b",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "4. U.S. DOT Grade Crossing Identification Number",
        isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "010",
      },
      {
        isValueOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field4",
        topAlign: true,
      },
      {
        title: "5. Date of Accident/Incident",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field5",
        topAlign: true,
      },
      {
        title: "6. Time of Accident/Incident",
        // isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        formatter: timeOfAccidentFormatter,
        accessor: "field6",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "7. Nearest Railroad Station",
        // isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field7",
        topAlign: true,
      },
      {
        title: "8. Subdivision",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field8",
        topAlign: true,
      },
      {
        title: "9. County",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field9",
        topAlign: true,
      },
      {
        title: "10. State Abbr.",
        isTitleOnly: true,
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "017",
      },
      {
        title: "Code",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field10",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "11. City (if in a city)",
        // isTitleOnly: true,
        colSpan: 7,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field11",
        topAlign: true,
      },
      {
        title: "12. Highway Name or Number",
        // isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field12", "field12a"],
        dontJoinValues: true,
        formatter: highwayNameFormatter,
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Highway User Involved",
        isTitleOnly: true,
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        // accessor: "021",
      },
      {
        title: "Rail Equipment Involved",
        isTitleOnly: true,
        colSpan: 9,
        rowSpan: 1,
        topAlign: true,
        // accessor: "022",
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "13. Type",
        isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        unBold: true,
        leftAlign: true,
        titleFormatter: HighwayUserTypeData,

        topAlign: true,
        // accessor: "023",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field13", "field13a"],
        dontJoinValues: true,
        formatter: ([code, other]) => {
          if (!code) return "";

          if (code === "M" && other) {
            return (
              <span
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              >
                M <br />({other})
              </span>
            );
          }

          return (
            <span
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {code}
            </span>
          );
        },
        topAlign: true,
      },
      {
        title: "17. Equipment",
        isTitleOnly: true,
        titleFormatter: EquipmentData,
        colSpan: 8,
        rowSpan: 1,
        unBold: true,
        leftAlign: true,
        topAlign: true,
        // accessor: "025",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field17", "field17a"],
        dontJoinValues: true,

        topAlign: true,
        formatter: ([code, other]) => {
          if (!code) return null;

          const style = {
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          };

          if (code === "8" && other) {
            return (
              <span style={style}>
                8 <br />({other})
              </span>
            );
          }

          return <span style={style}>{code}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "14. Vehicle Speed (est. mph at impact)",
        // isTitleOnly: true,
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field14",
        topAlign: true,
      },
      {
        title: "15. Direction (geographical)",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: DirectionData,
        unBold: true,
        topAlign: true,
        // accessor: "028",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field15",
        topAlign: true,
      },
      {
        title: "18. Position of Car Unit In Train",
        // isTitleOnly: true,
        colSpan: 9,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field18",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "16. Position",
        isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: PositionData,
        topAlign: true,
        // accessor: "031",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field16",
        topAlign: true,
      },
      {
        title: "19. Circumstance",
        isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: CircumstanceData,
        topAlign: true,
        // accessor: "033",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field19",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "20a. Was the highway user and/or rail equipment involved In the impact transporting hazardous materials?",
        isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: HazardousMaterialInvolvedData,
        unBold: true,
        topAlign: true,
        // accessor: "035",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field20a",
        topAlign: true,
      },
      {
        title: "20b. Was there a hazardous materials release by",
        isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        unBold: true,
        leftAlign: true,
        titleFormatter: HazardousMaterialReleasedData,
        topAlign: true,
        // accessor: "037",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field20b",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "20c.  State here the name and quantity of the hazardous material released, if any",
        // isTitleOnly: true,
        colSpan: 15,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field20c",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "21. Temperature",
        // isTitleOnly: true,
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field21",
        topAlign: true,
        formatter: (val) => {
          if (!val || val === 0 || val === undefined) {
            return "";
          } else {
            return `${val} °F`;
          }
        },
      },
      {
        title: "22. Visibilty (single entry) ",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: VisibilityData,
        topAlign: true,
        unBold: true,
        // accessor: "041",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field22",
        topAlign: true,
      },
      {
        title: "23. Weather (single entry)",
        isTitleOnly: true,
        colSpan: 7,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: WeatherData,
        topAlign: true,
        unBold: true,
        // accessor: "043",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field23",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "24. Types of Equipments Consist",
        isTitleOnly: true,
        colSpan: 6,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: TypeOfEquipmentData,
        topAlign: true,
        unBold: true,
        // accessor: "045",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field24",
        topAlign: true,
      },
      {
        title: "25. Track Type Used by Rail Equipment lnvolved",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        unBold: true,
        leftAlign: true,
        titleFormatter: TrackTypeUsedData,
        topAlign: true,
        // accessor: "047",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field25",
        topAlign: true,
      },
      {
        title: "26. Track Number or Name",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field26",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "27. FRA Track Class (1-9, X)",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field27",
        topAlign: true,
      },
      {
        title: "28. Number of Locomotive Units",
        // isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        accessor: "field28",
      },
      {
        title: "29. Number of Cars",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        accessor: "field29",
      },
      {
        title: "30. Consist Speed",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field30a"],
        topAlign: true,
        unBold: true,
        titleFormatter: ConstantSpeedData,
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field30", "field30a"],
        dontJoinValues: true,
        topAlign: true,
        formatter: ([code, mph]) => {
          if (!code || code === 0) {
            return "";
          }
          if (code === "U") {
            return code;
          }
          if (code === "R" || code === "E") {
            return (
              <span>
                {code} {mph} (MPH)
              </span>
            );
          }
          return code;
        },
      },
      {
        title: "31. Time Table Dlreclon",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: TimeTableDirectionData,
        topAlign: true,
        // accessor: "055",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field31",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "32. Types of Crossing Warning",
        isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: CrossingWarningTypeData,
        topAlign: true,
        unBold: true,
        // accessor: "057",
      },
      {
        title: "33. Signaled Crossing Warning",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 2,
        leftAlign: true,
        topAlign: true,
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 2,
        leftAlign: true,
        accessor: ["field33a", "field33b"],
        dontJoinValues: true,
        topAlign: true,
        formatter: ([code, comment]) => {
          return (
            <span>
              {code} {comment}
            </span>
          );
        },
      },
      {
        title: "34. Roadway Conditions",
        isTitleOnly: true,
        colSpan: 2,
        rowSpan: 2,
        leftAlign: true,
        unBold: true,
        titleFormatter: RoadwayConditionData,
        topAlign: true,
        // accessor: "060",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 2,
        leftAlign: true,
        accessor: "field34",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Code(s)",
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        dontJoinValues: true,
        formatter: codeFormatter(crossingWarningTypeData),
        accessor: [
          "field32",
          "field32a",
          "field32b",
          "field32c",
          "field32d",
          "field32e",
          "field32f",
          "field32g",
          "field32h",
          "field32i",
          "field32j",
          "field32k",
          "field32k1",
          "field32l",
        ],
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "35. Location of Warning",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: LocationOfWarningData,
        topAlign: true,
        unBold: true,
        // accessor: "070",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        accessor: "field35",
      },
      {
        title: "36. Crossing Warning Interconnected with Highway Signals",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: CrossingWarningInterconnectedData,
        topAlign: true,
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field36",
        topAlign: true,
      },
      {
        title: "37. Crossing illuminated by Street lights or Special lights",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: CrossingIlluminatedData,
        topAlign: true,
        // accessor: "074",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field37",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "38. Highway User's Age",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field38",
        topAlign: true,
      },
      {
        title: "39. Highway User's Sex",
        isTitleOnly: true,
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        titleFormatter: HighwayUserSexData,
        unBold: true,
        topAlign: true,
        // accessor: "077",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field39",
        topAlign: true,
      },
      {
        title: "40. Highway user Went Behind or In Front of Train and Struck or was Struck by Second Train",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: HighwayUserPositionData,
        topAlign: true,
        // accessor: "079",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field40",
        topAlign: true,
      },
      {
        title: "41. Highway User",
        isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: HighwayUserActionData,
        topAlign: true,
        // accessor: "081",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field41", "field41a"],
        dontJoinValues: true,
        formatter: ([code, other]) => {
          if (!code) return null;

          const wrapStyle = {
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          };

          if (code === "5" && other) {
            return (
              <span style={wrapStyle}>
                5 <br />({other})
              </span>
            );
          }

          return <span style={wrapStyle}>{code}</span>;
        },
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "42. Driver Passed Standing Highway Vehicle ",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: DriverPassedStandingVehicleData,
        topAlign: true,
        // accessor: "083",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        accessor: "field42",
      },
      {
        title: "43. View of Track Obscured by (primary obstruction)",
        isTitleOnly: true,
        colSpan: 10,
        rowSpan: 1,
        unBold: true,
        leftAlign: true,
        titleFormatter: TrackViewObstructionData,
        topAlign: true,
        // accessor: "085",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field43", "field43a"],
        topAlign: true,
        dontJoinValues: true,
        formatter: ([code, other]) => {
          if (!code) return null;

          const wrapStyle = {
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
          };

          if (code === "7" && other) {
            return (
              <span style={wrapStyle}>
                7 <br />({other})
              </span>
            );
          }

          return <span style={wrapStyle}>{code}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Casualties to",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        // accessor: "087",
      },
      {
        title: "Killed",
        isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        // accessor: "088",
      },
      {
        title: "Injured",
        isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        // accessor: "089",
      },
      {
        title: "44. Driver was",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        unBold: true,
        titleFormatter: DriverConditionData,
        // accessor: "090",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        accessor: "field44",
      },
      {
        title: "45. Was Driver in the Vehicle?",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 1,
        leftAlign: true,
        unBold: true,
        titleFormatter: DriverInVehicleData,
        topAlign: true,
        // accessor: "092",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field45",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "46. Highway-Rail Crossing Users",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "094",
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field46_killed",
        topAlign: true,
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field46_injured",
        topAlign: true,
      },
      {
        title: "47. Highway Vehicle Property Damage (est, dollar damage)",
        // isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field47",
        topAlign: true,
      },
      {
        title: "48. Total Number of Vehicle Occupants (including driver)",
        // isTitleOnly: true,
        colSpan: 5,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field48",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "49. Railroad Employees",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "099",
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field49_killed",
        topAlign: true,
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field49_injured",
        topAlign: true,
      },
      {
        title: "50. Total Number of People on Train (include passengers and train crew)",
        // isTitleOnly: true,
        colSpan: 5,
        rowSpan: 2,
        leftAlign: true,
        accessor: "field50",
        topAlign: true,
      },
      {
        title: "51. Is a Rail Equipment Accident/Incident Report Being Filed?",
        isTitleOnly: true,
        colSpan: 4,
        rowSpan: 2,
        leftAlign: true,
        titleFormatter: RailIncidentReportData,
        topAlign: true,
        unBold: true,
        // accessor: "103",
      },
      {
        title: "Code",
        // isTitleOnly: true,
        colSpan: 1,
        rowSpan: 2,
        leftAlign: true,
        accessor: "field51",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "52. Passengers on Train",
        isTitleOnly: true,
        colSpan: 3,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "105",
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field52_killed",
      },
      {
        isValueOnly: true,
        colSpan: 1,
        rowSpan: 1,
        accessor: "field52_injured",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "53a. Special Study Block",
        // isTitleOnly: true,
        colSpan: 8,
        rowSpan: 1,
        leftAlign: true,
        accessor: ["field53a", "field53a1"],
        topAlign: true,
        dontJoinValues: true,
        formatter: specialStudyBlockFormatter,
      },
      {
        title: "53b. Special Study Block",
        // isTitleOnly: true,
        colSpan: 7,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field53b",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "54. Narrative Description",
        // isTitleOnly: true,
        colSpan: 15,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field54",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "55. Typed Name & Title",
        // isTitleOnly: true,
        colSpan: 7,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field55",
        topAlign: true,
      },
      {
        title: "56. Signature",
        colSpan: 6,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field56",
        Signature: true,
        topAlign: true,
      },
      {
        title: "57. Date",
        // isTitleOnly: true,
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        accessor: "field57",
        topAlign: true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title:
          "NOTE: This report is part of the reporting railroad's accident report pursuant to the accident reports statute and, as such shall not 'be admitted as evidence or used for any purpose in any suit or action for damages growing out of any matter mentioned in said report....' 49 U.S.C. 20903. See 49 C.F.R. 225.7 (b).",
        isTitleOnly: true,
        colSpan: 15,
        rowSpan: 1,
        leftAlign: true,
        topAlign: true,
        // accessor: "114",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/HighBall/GradeCrossingAccidentReport/Schema.jsx